"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_options_preview_table_html_1 = __importDefault(require("./global-options-preview-table.html"));
(function (module) {
    'use strict';
    function GlobalOptionsPreviewTableController($scope) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        angular.extend($ctrl, {
            getWidgetPaddingStyle: function () {
                return {
                    'padding': $ctrl.widgetPadding
                };
            },
            getWidgetTableBodyDensity: function () {
                return {
                    'padding': $ctrl.widgetTableBodyDensity
                };
            }
        });
    }
    GlobalOptionsPreviewTableController.$inject = [
        '$scope'
    ];
    module.component('prGlobalOptionsPreviewTable', {
        templateUrl: global_options_preview_table_html_1.default,
        controller: GlobalOptionsPreviewTableController,
        bindings: {
            widgetPadding: '<',
            widgetTableBodyDensity: '<',
        }
    });
})(angular.module('qualtrics.pr'));
